import { Col, Row, Spin,Modal } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory, useRouteMatch } from "react-router";
import { Alerta } from "../../../../constants";
import ActionBar from "../../../../components/action-bar";
import ActionButton from "../../../../components/action-button";
import TextAnexo from "../../../../components/text-anexo";
import TextItem from "../../../../components/text-item";
import useFormatter from "../../../../hooks/useFormatter";
import useLoading from "../../../../hooks/useLoading";
import { documentoSelector, fetchDocumento, isEditableSelector } from "../../../../store/empresa";
import { openPopup, openPopupAssinaturas } from "../../../../util/window";
import { EmpresaDocumento, findByIdAndMap } from "../../../../constants";
import useModulo from "../../../../hooks/useModulo";
import { documentosAlertaNivelSelector } from "../../../../store/empresa";
import TarefasDrawer from "../../licencas/_tarefasDrawer";
import { useLocation } from "react-router";
import { useState } from "react";
import { verificarAssinatura } from "../../../../store/assinatura";
import useDispatchWithResult from "../../../../hooks/useDispatchWithResult";

const { Aviso } = EmpresaDocumento;

export default function EmpresaDocumentoDetailPage() {
  const { t } = useTranslation();
  const isEditable = useSelector(isEditableSelector);
  const documento = useSelector(documentoSelector);
  const nivel = useSelector(documentosAlertaNivelSelector);
  const { formatCurrency, formatDate, formatDateTime, formatBoolean } = useFormatter();
  const loading = useLoading(fetchDocumento.typePrefix);
  const history = useHistory();
  const match = useRouteMatch();
  const empresaId = match.params.empresaId;
  const id = match.params.id;
  const { moduloBasePath } = useModulo();
  const location = useLocation();
  const dispatch = useDispatchWithResult();
  const pathname = location.pathname;
  const origem = pathname.substring(pathname.indexOf("/empresas"));
  const modulo = pathname.split("/")[1];
  const [tarefasDrawerVisible, setTarefasDrawerVisible] = useState(false);

  const handleOpenPopupAssinaturas = () => {
    const anexo = documento?.anexo
    const uid = anexo?.uid;

dispatch(verificarAssinatura())
  .then((response) => {
    if (!uid || !uid.includes("/")) {
      message.error("É necessário salvar o anexo antes da assinatura.");
      return;
    }
    openPopupAssinaturas(uid);
  })
  .catch((response) => {
    Modal.error({
      title: "Erro ao enviar para assinatura",
      content: response.mensagem,
      centered: true,
    });
  });


  };

  const isNA = nivel === Alerta.Nivel.NA.id || nivel === Alerta.Nivel.inativo.id;

  const handleEdit = () => {
    history.replace(`${moduloBasePath}/empresas/${empresaId}/documentos/${id}/edit`);
  };

  const handleBack = () => {
    history.replace(`${moduloBasePath}/empresas/${empresaId}/documentos`);
  };

  const handleLogs = () => {
    openPopup(`/logs?categoria=/empresas/${empresaId}/documentos/${id}/`, `logs_/empresas/${empresaId}/documentos/${id}/`);
  };
  return (
    <Spin spinning={loading}>
      <TarefasDrawer visible={tarefasDrawerVisible} origem={origem} modulo={modulo} empresaId={empresaId} unidade={documento.unidade} onClose={() => setTarefasDrawerVisible(false)} />
      <ActionBar>
        <ActionButton.Tarefa disabled={isNA} onClick={() => setTarefasDrawerVisible(true)} />
        {isEditable && <ActionButton.Edit onClick={handleEdit} disabled={isNA} />}
        <ActionButton.Back onClick={handleBack} />
        <ActionButton.Logs noTitle onClick={handleLogs} />
      </ActionBar>
      <Row gutter={[16, 8]}>
        <Col flex="600px">
          <TextItem label={t("Unidade")}>{documento?.unidade ? documento.unidade.id + " - " + documento.unidade.apelido : ""}</TextItem>
        </Col>
      </Row>
      <Row gutter={[16, 8]}>
        <Col flex="400px">
          {" "}
          <TextItem label={t("Nome")}>{documento?.nome}</TextItem>{" "}
        </Col>
        <Col flex="200px">
          {" "}
          <TextItem label={t("Área Responsável")}>{documento?.areaResponsavel}</TextItem>{" "}
        </Col>
      </Row>
      <Row gutter={[16, 8]}>
        <Col flex="200px">
          <TextItem label={t("Data da Publicação")}>{formatDate(documento?.dataPublicacao)}</TextItem>
        </Col>
        <Col flex="200px">
          <TextItem label={t("Revisão")}>{formatBoolean(documento?.revisao)}</TextItem>
        </Col>
        <Col flex="200px">{documento?.revisao === true && <TextItem label={t("Data Limite para Revisão")}>{formatDate(documento?.dataLimiteRevisao)}</TextItem>}</Col>
        <Col flex="200px">{documento?.revisao === true && <TextItem label={t("Controle de Prazo")}>{findByIdAndMap(Aviso, documento?.aviso, (aviso) => t(aviso.label))}</TextItem>}</Col>
      </Row>
      <Row gutter={[16, 8]}>
        <Col flex="400px">
          {" "}
          <TextItem label={t("Site")}>{documento?.site}</TextItem>{" "}
        </Col>
      </Row>
      <Row gutter={[16, 8]}>
        <Col flex="800px">
          <TextItem label={t("Conteúdo")}>{documento?.conteudo}</TextItem>
        </Col>
      </Row>
      <Row gutter={[16, 8]}>
        <Col flex="200px">
            <TextAnexo label={t("Anexo")} value={documento?.anexo} />
          </Col>
          { documento?.anexo && <Col flex="200px">
            <ActionButton.Assinatura onClick={handleOpenPopupAssinaturas}  style={{ marginTop: '11px' }}/>
          </Col>}
      </Row>
      <Row gutter={[16, 8]}>
        <Col flex="800px">
          <TextItem label={t("Observação")}>{documento?.obs}</TextItem>
        </Col>
      </Row>
      <Row gutter={[16, 8]}>
        <Col flex="200px">
          <TextItem label="Criado em">{formatDateTime(documento?.createdAt)}</TextItem>
        </Col>
        <Col flex="200px">
          <TextItem label="Alterado em">{formatDateTime(documento?.updatedAt)}</TextItem>
        </Col>
        <Col flex="200px">
          <TextItem label="Id">{empresaId}</TextItem>
        </Col>
      </Row>
    </Spin>
  );
}
